<template>
  <my-dialog class="offer-dialog" :show="show" :title="title" @close="onClose">
    <div class="account-name">{{ bidderInfo.TenderName }}</div>
    <div class="location">
      <i class="icon-location">
        <svg
          class="icon"
          style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2530"
        >
          <path
            d="M511.968 0c-207.84 0-376.96 169.12-376.96 376.992 0 54.208 11.104 105.984 32.96 153.888 94.24 206.24 274.976 424 328.128 485.824 3.968 4.608 9.792 7.296 15.904 7.296s11.904-2.656 15.904-7.296c53.12-61.824 233.856-279.552 328.128-485.824 21.888-47.904 32.96-99.648 32.96-153.888-0.032-207.872-169.152-376.992-376.992-376.992zM511.968 572.8c-107.968 0-195.808-87.84-195.808-195.808s87.84-195.84 195.808-195.84 195.808 87.84 195.808 195.84c0 107.968-87.84 195.808-195.808 195.808z"
            p-id="2531"
          ></path>
        </svg>
      </i>
      {{ bidderInfo.StartingAddress }} |
      {{ bidderInfo.JobDistance }}km
    </div>
    <div class="price-area">
      <div class="price-item">
        <span class="name">预计服务天数：</span>
        <span class="count">{{ plan.WorkLogDayCount}}</span>
      </div>
      <div class="price-item">
        <span class="name">服务报价：</span>
        <span class="count">￥{{ plan.WorkLogAmountTax}}</span>
      </div>
      <div class="price-item">
        <span class="name">交通费用：</span>
        <span class="count">￥{{ plan.TrafficAmountTax}}</span>
      </div>
      <div class="price-item">
        <span class="name">住宿费用：</span>
        <span class="count">￥{{ plan.HousingAmountTax}}</span>
      </div>
      <div class="price-item">
        <span class="name">总费用：</span>
        <span class="count">￥{{ plan.TotalAmountTax}}</span>
      </div>
    </div>
    <div class="cert-item">
      <span class="label">优惠券</span>
      <div class="value align-right" @click="isDrop=!isDrop">
        <span class="disabled" v-if="couponCount == 0">暂无可用</span>
        <span
          class="btn-default"
          v-if="couponCount != 0 && minusCount == 0"
          @click="isShowCoupon = !isShowCoupon"
          >{{ couponCount }}张可用</span
        >
        <span
          class="price"
          v-if="couponCount != 0 && minusCount > 0"
          @click="isShowCoupon = !isShowCoupon"
          >-￥{{ minusCount | formatPrice }}</span
        >
        <i :class="['el-icon el-icon-arrow-down',isDrop?'on':'']"></i>
      </div>
    </div>
    <div class="coupon-box" :style="{height:isDrop?'200px': 0}">
      <ul class="coupon-list clear">
        <li :class="{'on':index==checked}" v-for="(item,index) in couponList" :key="index" @click="pickCoupon(index)">
          <div class="dt">
            <div class="type-name">
              <div>
                {{item.CouponTypeStr}}
                <template v-if="item.CouponType !=3 || (item.CouponType ==1 && item.UseScope!=5)">
                  —{{item.UseScopeStr}}
                </template>
              </div>
              <template v-if="item.CouponType !=3">
                {{item.UsePermissionStr}}
              </template>
            </div>
            <div class="flex">
              <div class="count" v-if="item.CouponMode ==1">¥{{item.FullReduceOffAmount}}</div>
              <div class="count" v-if="item.CouponMode ==2">{{item.OffAmount}} <span class="unit">折</span></div>
              <div class="count" v-if="item.CouponMode ==3">¥{{item.OffAmount}}</div>
              <div class="desc">{{item.CouponModeStr}}</div>
            </div>
            <span class="expire" v-if="item.IsDisplayDateIco">{{item.EffectivityEndTime}}</span>
          </div>
          <div class="dd">
            <span class="time">{{item.EffectivityEndTime}}</span>
            <i class="el-icon el-icon-check"></i>
          </div>
        </li>
        <div class="no-data" v-if="couponList.length==0">暂无可用</div>
      </ul>
    </div>
    <div class="total">
      总计：<i class="amount"
        >￥{{ (plan.TotalAmountTax - minusCount) | formatPrice }}</i
      >
    </div>

    <div class="dialog-bottom">
      <div class="btn-pay" @click="pay">选为中标人</div>
    </div>
  </my-dialog>
</template>
<script>
import myDialog from "./gkDialog.vue";
import {mapState} from 'vuex'
import {
  GetJobTenderInfo,
  GetServiceSiteInfo,
  GetUserEngineerInfo,
  CreatePayOrder,
  GetUsableCouponList,
  GetAfterDiscountsAmount,
} from "@/scripts/api.js";
export default {
  components: {
    myDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "接单人的报价",
    },
    jobId:{
      type:[Number,String],
      default:0
    },
  },
  data() {
    return {
      jobNo:'',
      plan:{},
      bidderInfo:{},
      isShowCoupon:false,
      couponList:[],
      couponCount:0,
      unabledCouponList:[],
      minusCount:0,//减掉的金额
      pickedCoupon:null,
      checked:-1,
      orderId:0,
      isDrop:false,
    };
  },
  computed:{
		...mapState({
			userInfo:state=>state.userInfo,
		})
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    pageInit(orderId){
      this.orderId=orderId;
      this.getTenderInfo(orderId);
    },
    getTenderInfo(orderId){
      let params={
        JobApplyOrderId:orderId,
        ViewerType:1,//发单方
      }
      GetJobTenderInfo(params).then(r=>{
      if (r.Result == 1) {
          this.bidderInfo = {
            ...r.Data,
            ...r.Data.AddressVO
          };
          this.plan = r.Data.PriceDto;
          this.jobId=r.Data.JobId;
          this.getCouponList(orderId);
        } else {
          this.$toast(r.Message);
        }
      })
    },
    //工程师信息
    engineerInfo(id) {
      GetUserEngineerInfo({ platform: "pcweb", UserID: id }).then((r) => {
        if (r.Result == 1) {
          this.bidderInfo = r.Data;
          this.bidderInfo["type"] = 1;
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //服务站信息
    companyInfo(id) {
      GetServiceSiteInfo({ platform: "pcweb", CompanyID: id }).then((r) => {
        if (r.Result == 1) {
          this.bidderInfo = r.Data;
          this.bidderInfo["type"] = 2;
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //获取用户可用优惠券
    getCouponList(id) {
      this.pickedCoupon = null;
      let params = {
        UserCode: this.userInfo.UserCode,
        JobId: this.jobId,
        PageNum: 1,
        PageSize: 999,
        ApplyOrderId: id,
        WhoUseTypes: 1,
        platform: "pcweb",
      };
      GetUsableCouponList(params).then((r) => {
        if (r.Result == 1) {
          this.couponList = r.Data.UsableCouponList || [];
          this.couponCount = r.Data.UsableCouponCounts;
          this.unabledCouponList = r.Data.NoUsableCouponList || [];
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //选择优惠券
    pickCoupon(index) {
      this.checked=index;
      this.pickedCoupon = this.couponList[index];
      GetAfterDiscountsAmount({
        JobId: this.jobId,
        PayBusinessType: 2,
        CouponId: this.pickedCoupon.Id,
        ApplyOrderId: this.orderId,
        platform: "pcweb",
      }).then((r) => {
        if (r.Result == 1) {
          this.minusCount = r.Data.OffAmount;
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //支付并选为中标人
    pay() {
      //isAdd是否追加押金
      let params = {
        OuterOrderType: 2,
        OuterOrderId: this.orderId,
        TradeType: 2, //1：B2B平台，2：自由平台，3：追加押金
        UserCouponId: this.pickedCoupon ? this.pickedCoupon.Id : 0, //优惠券id
        platform: "pcweb",
      };
      CreatePayOrder(params).then((r) => {
        this.isShow = false;
        if (r.Result == 1) {
          this.onClose();
          this.$router.push({
            path: "/payment",
            query: {
              payId: r.Data.PayId,
            },
          });
          // window.open(r.Data.PcPayUrl,'_blank');
        } else {
          this.$toast(r.Message);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.offer-dialog {
  .account-name {
    font-size: 18px;
    color: #333;
    line-height: 30px;
    font-weight: bold;
    max-width: 700px;
    margin-bottom: 12px;
  }
  .location {
    font-size: 14px;
    color: #333;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .icon-location {
    color: #f75959;
  }

  .price-area {
    padding: 16px 0px 6px;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #e5e5e5;
  }
  .price-item {
    overflow: hidden;
    margin-bottom: 10px;
    color: #333;
    line-height: 24px;
    .name {
      float: left;
      font-size: 14px;
      width: 30%;
    }
    .count {
      float: right;
      font-size: 16px;
      font-family: "DIN-Regular";
      width: 70%;
      text-align: right;
      font-weight: bold;
    }
  }

  .cert-item {
    overflow: hidden;
    margin-bottom: 10px;
    margin-top: 10px;
    position: relative;
    .label {
      float: left;
      font-size: 14px;
      color: #999;
      line-height: 28px;
      width: 100px;
      float: left;
    }
    .align-right {
      float: right;
      line-height: 28px;
      cursor: pointer;
      user-select: none;
    }
    .btn-default{
      font-size: 14px;
      color: #f75959;
    }
    .disabled {
      font-size: 12px;
      color: #999;
      vertical-align: middle;
    }
    .price{
      color: #f75959;
    }
    .el-icon-arrow-down {
      color: #666;
      vertical-align: middle;
      cursor: pointer;
      transition: all 0.2s linear;
      &.on{
        transform: rotate(-180deg);
      }
    }
  }
  .coupon-box{
    width: 100%;
    height: 0px;
    transition: height 0.2s linear;
    overflow-y: auto;
    margin-bottom: 10px;
    margin-top: 10px;
    border-bottom: 1px solid #e5e5e5;
  }
  .coupon-list{
    width: 100%;
    >li{
      float: left;
      width: 200px;
      height: 164px;
      margin-right: 14px;
      margin-bottom: 10px;
      background: #f9f9f9 ;
      background-size: contain;
      border: 2px solid transparent;
      box-sizing: content-box;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      &.on{
        border: 2px solid #f75959;
        &:after{
          content: "";
          position: absolute;
          right: -32px;
          bottom: -32px;
          width: 60px;
          height: 60px;
          background-color: #f75959;
          transform: rotate(315deg);
        }
      }
      &:nth-child(3n){
        margin-right: 0;
      }
      .dt{
        height: 120px;
        padding: 5px 6px;
        position: relative;
        background:  url('~@/assets/coupon/bg-active.png') no-repeat center top;
        &.disabled{
          background:  url('~@/assets/coupon/bg-disabled.png') no-repeat center top;
        }
        .order-type,.type-name{
          font-size: 12px;
          color: #fff;
          line-height: 18px;
          text-align: left;
        }
        .flex{
          overflow: hidden;
          position: absolute;
          left: 0px;
          bottom: 20px;
          width: 100%;
          z-index: 2;
          padding: 0 6px;
        }
        .count{
          display: inline-block;
          text-align: center;
          font-size: 48px;
          line-height: 1;
          color: #fff;
          font-weight: bold;
          font-family: "DIN-Regular";
          .unit{
            font-size: 16px;
            font-weight: normal;
          }
        }
        .desc{
          display: inline-block;
          text-align: center;
          font-size: 16px;
          color: #fff;
          line-height: 18px;
          margin-left: 20px;
        }
        .expire{
          position: absolute;
          right: -33px;
          top: -23px;
          font-size: 12px;
          color: #fff;
          line-height: 104px;
          text-align: center;
          width: 80px;
          height: 60px;
          background-color: #00B4FF;
          white-space: nowrap;
          transform: rotate(45deg);
        }
      }
      .dd{
        height: 40px;
        padding:10px 10px;
        .time{
          display: block;
          font-size: 14px;
          line-height: 20px;
          color: #333;
        }
      }
      .el-icon-check{
        position: absolute;
        right: 4px;
        bottom: 4px;
        font-size: 18px;
        color: #fff;
        z-index: 3;
      }
    }
  }
  .total{
    text-align: right;
    font-size: 18px;
    color: #333;
    line-height: 30px;
    margin-bottom: 20px;
    .amount{
      color: #f75959;
      font-size: 20px;
      font-weight: bold;
      font-family: 'DIN-Regular';
    }
  }
  .dialog-bottom {
    text-align: center;
    .btn-pay {
      width: 100px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      background-color: #f75959;
      display: inline-block;
      text-align: center;
      color: #fff;
      cursor: pointer;
      &:hover {
        background-color: #ff3838;
        color: #fff;
      }
    }
  }
}
</style>
